import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon, Image, Divider } from 'semantic-ui-react';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';

import HelpLink from '../help-link';

const contentStyle = {
  color: 'gray',
  padding: '25px 0',
};

const wrapperStyle = {
  padding: '50px 0',
  textAlign: 'center',
};

const imageProps = {
  display: 'block',
  margin: '0 auto',
};

const buttonStyle = {
  margin: '0 auto',
  display: 'block',
};

const contexts = {
  CAMPAIGNS: {
    imageSrc: '/images/empty-campaigns.svg',
  },
  INFLUENCER: {
    imageSrc: '/images/no-influencers.svg',
  },
};

const DyzioEmptyState = props => {
  const { content, onClick, buttonLabel, isSearchContext, helpUrl, context } = props;
  return (
    <div style={wrapperStyle}>
      <Image src={_.get(contexts, context).imageSrc} style={imageProps} />
      <h4 style={contentStyle}>{content}</h4>
      {
        !isSearchContext &&
        <div>
          <DyzioPrimaryButton
            label={buttonLabel}
            hasIcon
            floated={null}
            style={buttonStyle}
            onClick={onClick}
            icon={<Icon name="plus" />}
          />
          <Divider hidden />
          <HelpLink url={helpUrl} />
        </div>
      }
    </div>
  );
};

DyzioEmptyState.propTypes = {
  content: PropTypes.any.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isSearchContext: PropTypes.bool.isRequired,
  context: PropTypes.string.isRequired,
  helpUrl: PropTypes.string.isRequired,
};

export default DyzioEmptyState;



/** WEBPACK FOOTER **
 ** ./src/components/dyzio-empty-state/index.js
 **/